export default __webpack_public_path__ + "static/media/featured.a2ba2e37.svg";